// extracted by mini-css-extract-plugin
export default {"select":"Select_select__aeuTF","menu":"Select_menu__caAZg"};